import React from 'react';

export default function ServicePortalWrapper(props) {
    return <section className='sp-container tw-container tw-m-auto tw-flex py-3 tw-gap-10 tw-flex-grow tw-overflow-hidden' {...props} />
}
